// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_SORTIE,
  ADD_SORTIE,
  UPDATE_SORTIE,
  DELETE_SORTIE,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getSortie = ({ dispatch }, projectId) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('sortie/project/' + projectId)
      .then(
        (response) => {
          dispatch(GET_SORTIE, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}

/**
 * Add a new sortie
 * @param dispatch
 * @param sortie
 */
export const addSortie = ({ dispatch }, sortie) => {
  Vue.http
    .post('sortie', sortie)
    .then(
      (response) => {
        let data = JSON.parse(response.data)
        dispatch(ADD_SORTIE, data)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Edit a sortie
 *
 * @param dispatch
 * @param oldContact The former sortie data
 * @param newContact The new sortie data
 */
export const editSortie = ({ dispatch }, oldSortie, newSortie) => {
  Vue.http
    .put('sortie/' + newSortie.id, newSortie)
    .then(
      (response) => {
        dispatch(UPDATE_SORTIE, oldSortie, newSortie)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Delete a sortie
 *
 * @param dispatch
 * @param sortie
 */
export const deleteSortie = ({ dispatch }, sortie) => {
  Vue.http.delete('sortie/' + sortie.id)
    .then(
      (response) => {
        dispatch(DELETE_SORTIE, sortie)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}



// WEBPACK FOOTER //
// ./src/vuex/actions/sortieActions.js